




















import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType,
    pageDataType
} from "../types";
import "swiper/dist/css/swiper.css";
import {
    swiper,
    swiperSlide
} from "vue-awesome-swiper";
import {
    pageData
} from "../store/pageData";
import {
    HOST
} from "../global";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
import {
    TimelineMax,
    Power1,
    Power2,
    Power4
} from "gsap";
@Component({
    name: "HomeSlider",
    components: {
        swiper,
        swiperSlide
    }
})
export default class HomeSlider extends Vue {
    @Prop() readonly slides!: any;
    public HOST: string = HOST;
    @Getter("pageData") public pageData!: pageDataType;
    @Prop() public compData!: string | null;
    public original: any | null = null;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
    public swiperOption: any = {
        spaceBetween: 30,
        effect: 'fade',
        speed: 800,
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        direction: "horizontal",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        }
    };

}
